import _ from 'lodash';
import { connect } from 'react-redux';
import { add, update, get, reRunMatchResults } from '../../modules/apAutomation/apIngestionResult';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	const apIngestionResultId = _.get(ownProps, ['match', 'params', 'apIngestionResultId']);
	const apIngestionResult = apIngestionResultId
		? _.get(state.maps, ['apIngestionResult', apIngestionResultId])
		: undefined;

	return {
		apIngestionResult,
		apIngestionDocumentMap: state.maps.apIngestionDocument,
		bolNumberToInvoiceMap: state.maps.bolNumberToInvoice,
		carrierMap: state.maps.carrier,
		carrierPoNumberToInvoiceMap: state.maps.carrierPoNumberToInvoice,
		quickbooksTermMap: state.maps.quickbooksTerm,
		quickbooksVendorMap: state.maps.quickbooksVendor,
		resourceMap: state.maps.resource,
		supplierMap: state.maps.supplier,
		terminalMap: state.maps.terminal,
		stationMap: state.maps.station,
		stationDeliveryMap: state.maps.stationDelivery,
		stationInvoiceMap: state.maps.stationInvoice,
		userMap: state.maps.user,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			apIngestionResultAdd: add,
			apIngestionResultUpdate: update,
			apIngestionResultGet: get,
			apIngestionResultRerun: reRunMatchResults,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
